// extracted by mini-css-extract-plugin
module.exports = {"hero":"Y_d0"};